/* eslint-disable no-empty */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';


// For Coupons (discount API)

// Create (POST)
export const createDiscountData = createAsyncThunk('create discount data', async (newData) => {
  const response = await $axios.post('/marketing/discount', newData);
  return response.data;
});

// List (GET)
export const fetchDiscounts = createAsyncThunk('fetch discounts', async ({ page = 1, limit = 12 }) => {
  const response = await $axios.get(`/marketing/discount?page=${page}&limit=${limit}`);
  return response.data;
});

// Single (GET)
export const fetchSingleDiscount = createAsyncThunk('fetch single discount', async (id) => {
  const response = await $axios.get(`/marketing/discount/${id}`);
  return response.data;
});

// Orders using this coupon (GET)
export const fetchDiscountOrders = createAsyncThunk('fetch discount orders', async (id) => {
  const response = await $axios.get(`/marketing/discount/${id}/orders`);
  return response.data;
});

// Update (PUT)
export const updateDiscount = createAsyncThunk('update discount', async ({ id, data }) => {
  const response = await $axios.put(`/marketing/discount/${id}`, data);
  return response.data;
});




// For Email Campaign
export const fetchEmailCampaigns = createAsyncThunk('fetch email campaigns', async ({ page = 1, limit = 12 } = {}) => {
  const response = await $axios.get(`/marketing/email-campaign?page=${page}&limit=${limit}`);
  return response.data;
});

export const fetchSingleEmailCampaign = createAsyncThunk('fetch single email campaign', async (id) => {
  const response = await $axios.get(`/marketing/email-campaign/${id}`);
  return response.data;
});

export const createEmailCampaign = createAsyncThunk('create email campaign data', async (newData) => {
  const response = await $axios.post('/marketing/email-campaign', newData);
  return response.data;
});

export const sendEmailCampaign = createAsyncThunk('send email campaign', async (campaignId) => {
  const response = await $axios.post(`/marketing/email-campaign/${campaignId}/send`);
  return response.data;
});

// Slice
const marketingSlice = createSlice({
  name: 'marketingSlice',
initialState: {
  // Email Campaign state
  emailCampaigns: [],
  emailCampaignsList: [],
  emailCampaignsTotal: 0,
  singleEmailCampaign: null,
  newEmailCampaign: null,
  newEmailCampaignError: false,
  sendEmailCampaignLoading: false,
  sendEmailCampaignError: null,
  sendEmailCampaignMessage: null,

  // Discount/Coupons state
  discounts: [],
  newDiscount: null,
  newDiscountError: false,
  discountsList: [],
  discountsTotal: 0,
  singleDiscount: null,
  singleDiscountError: false,
  discountOrders: [],
  updatedDiscount: null,
  updatedDiscountError: false,

  // Common
  loading: false,
  error: null,
},

  reducers: {},
  extraReducers: (builder) => {

    // --------------------
    // Email Campaign
    // --------------------

    // Create Email Campaign
    builder
      .addCase(createEmailCampaign.pending, (state) => {
        state.newEmailCampaignError = false;
        state.newEmailCampaign = null;
        state.loading = true;
      })
      .addCase(createEmailCampaign.fulfilled, (state, action) => {
        state.loading = false;
        state.newEmailCampaign = action.payload;
        state.emailCampaigns.push(action.payload); 
      })
      .addCase(createEmailCampaign.rejected, (state, action) => {
        state.loading = false;
        state.newEmailCampaign = null;
        state.newEmailCampaignError = true;
        state.error = action.error.message;
      });

    builder
      .addCase(fetchEmailCampaigns.pending, (state) => { state.loading = true; })
      .addCase(fetchEmailCampaigns.fulfilled, (state, action) => {
        state.loading = false;
        state.emailCampaignsList = action.payload?.data || [];
        state.emailCampaignsTotal = action.payload?.total ?? 0;
      })
      .addCase(fetchEmailCampaigns.rejected, (state) => { state.loading = false; });

    builder
      .addCase(fetchSingleEmailCampaign.pending, (state) => {
        state.singleEmailCampaign = null;
        state.sendEmailCampaignMessage = null;
      })
      .addCase(fetchSingleEmailCampaign.fulfilled, (state, action) => {
        state.singleEmailCampaign = action.payload?.data || action.payload;
      })
      .addCase(fetchSingleEmailCampaign.rejected, (state) => { state.singleEmailCampaign = null; });

    builder
      .addCase(sendEmailCampaign.pending, (state) => {
        state.sendEmailCampaignLoading = true;
        state.sendEmailCampaignError = null;
      })
      .addCase(sendEmailCampaign.fulfilled, (state, action) => {
        state.sendEmailCampaignLoading = false;
        state.sendEmailCampaignError = null;
        state.sendEmailCampaignMessage = action.payload?.message || null;
        const data = action.payload?.data || action.payload;
        if (data && state.singleEmailCampaign?._id === data._id) {
          state.singleEmailCampaign = data;
        }
      })
      .addCase(sendEmailCampaign.rejected, (state, action) => {
        state.sendEmailCampaignLoading = false;
        state.sendEmailCampaignError = action.error?.message || 'Failed to send';
      });

   // --------------------
    // Discount
    // --------------------


    // Fetch Data
    // builder
    //   .addCase(fetchData.pending, (state) => {
    //     state.loading = true;
    //   })
    //   .addCase(fetchData.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.data = action.payload;
    //   })
    //   .addCase(fetchData.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.error.message;
    //   });

    // builder.addCase(resetDataGtmSlice.fulfilled, (state, action) => {
    //   state.data = [];
    //   state.newGtm = null;
    //   state.newGtmError = false;
    //   state.singleGtm = null;
    //   state.singleGtmError = false;
    //   state.updatedGtm = null;
    //   state.updatedGtmError = false;
    //   state.loading = false;
    //   state.error = null;
    // });

    // Fetch Single Data
    // builder
    //   .addCase(fetchSingleData.pending, (state) => {
    //     state.singleGtmError = false;
    //     state.loading = true;
    //     state.singleGtm = null;
    //   })
    //   .addCase(fetchSingleData.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.singleGtm = action.payload.data;
    //   })
    //   .addCase(fetchSingleData.rejected, (state, action) => {
    //     state.loading = false;
    //     state.singleGtm = null;
    //     state.singleGtmError = action.error;
    //   });

    // Create Discount Data
    builder
      .addCase(createDiscountData.pending, (state) => {
        state.newDiscountError = false;
        state.newDiscount = null;
        state.loading = true;
      })
      .addCase(createDiscountData.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload?.data || action.payload;
        state.newDiscount = action.payload;
        if (data) state.discounts.push(data);
      })
      .addCase(createDiscountData.rejected, (state, action) => {
        state.loading = false;
        state.newDiscount = null;
        state.newDiscountError = true;
        state.error = action.error.message;
      });

    // Fetch Discounts List (Coupons)
    builder
      .addCase(fetchDiscounts.pending, (state) => { state.loading = true; })
      .addCase(fetchDiscounts.fulfilled, (state, action) => {
        state.loading = false;
        state.discountsList = action.payload?.data || [];
        state.discountsTotal = action.payload?.total ?? 0;
      })
      .addCase(fetchDiscounts.rejected, (state) => { state.loading = false; });

    // Fetch Single Discount (Coupon)
    builder
      .addCase(fetchSingleDiscount.pending, (state) => {
        state.singleDiscountError = false;
        state.singleDiscount = null;
        state.loading = true;
      })
      .addCase(fetchSingleDiscount.fulfilled, (state, action) => {
        state.loading = false;
        state.singleDiscount = action.payload?.data || action.payload;
      })
      .addCase(fetchSingleDiscount.rejected, (state) => {
        state.loading = false;
        state.singleDiscount = null;
        state.singleDiscountError = true;
      });

    // Fetch Discount Orders
    builder
      .addCase(fetchDiscountOrders.fulfilled, (state, action) => {
        state.discountOrders = action.payload?.data || [];
      })
      .addCase(fetchDiscountOrders.rejected, (state) => {
        state.discountOrders = [];
      });

    // Update Discount (Coupon)
    builder
      .addCase(updateDiscount.pending, (state) => {
        state.updatedDiscountError = false;
        state.updatedDiscount = null;
      })
      .addCase(updateDiscount.fulfilled, (state, action) => {
        state.updatedDiscount = action.payload?.data || action.payload;
        if (state.singleDiscount && state.singleDiscount._id === (action.payload?.data || action.payload)?._id) {
          state.singleDiscount = action.payload?.data || action.payload;
        }
      })
      .addCase(updateDiscount.rejected, (state) => {
        state.updatedDiscountError = true;
      });

    // Update Data
    // builder
    // .addCase(updateData.pending, (state) => {
    //   state.updatedGtmError = false;
    //   state.loading = true;
    //   state.updatedGtm = null;
    // })
    // .addCase(updateData.fulfilled, (state, action) => {
    //   state.loading = false;
    //   state.updatedGtm = action.payload.data;
    // })
    // .addCase(updateData.rejected, (state, action) => {
    //   state.loading = false;
    //   state.updatedGtm = null;
    //   state.updatedGtmError = action.error;
    // });

    // Delete Data
//  builder.addCase(deleteData.fulfilled, (state, action) => {
//        if (Array.isArray(state.data)) {
//     state.data = state.data.filter(item => item._id !== action.payload);
//   }
//      });
  },
});

export default marketingSlice.reducer;
